import React, { useEffect } from "react";
import { Box, Divider, Typography } from "@mui/material";
import InventorySummary from "../pages/dashboard/InventorySummary";
import { SUCCESS_MESSAGES } from "../constant/messages";
import DashboardActions from "../pages/dashboard/DashboardActions";
import AnnualIncrement from "../pages/dashboard/AnnualIncrement";
import SalesChart from "../pages/dashboard/SalesChart";
import { useDispatch } from "react-redux";
import { showToast } from "../store/slices/toastSlice";

const DashboardContainer = () => {
  // -----------useState----------------------
  const dispatch = useDispatch();

  // ------------useEffect------------------------
  useEffect(() => {
    const loginSuccess = localStorage.getItem("loginSuccess");
    if (loginSuccess) {
      dispatch(
        showToast({
          message: SUCCESS_MESSAGES.USER_LOGGED_IN_SUCCESSFULLY,
          severity: "success",
        })
      );
      localStorage.removeItem("loginSuccess");
    }
  }, []);

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Typography
        variant="h3"
        sx={{ mb: 1, fontWeight: "bold", color: "#333" }}
      >
        Welcome to Dashboard
      </Typography>
      <Typography variant="h6" sx={{ mb: 4, color: "#666" }}>
        Here you can manage your sales, track recent transactions, and gain
        insights into your business performance.
      </Typography>
      <Divider sx={{ mb: 1 }} />
      <Divider sx={{ mb: 8 }} />

      <DashboardActions />
      <Divider sx={{ mt: 4 }} />

      <InventorySummary />
      <Divider sx={{ mb: 1 }} />

      <AnnualIncrement />

      <Divider sx={{ mt: 4 }} />

      <SalesChart />
    </Box>
  );
};

export default DashboardContainer;
